import { useState, ReactNode } from 'react';
import { useGlobalBackgroundSync, BackgroundSyncContext } from '@/hooks/useBackgroundSync';

/**
 * Provider component that enables global background sync.
 * Must be placed inside QueryClientProvider.
 * 
 * Features:
 * - Syncs stale data when user returns to tab after 30+ seconds
 * - Exposes isSyncing state via context for UI indicators
 * - Logs sync activity in development mode
 */
export function BackgroundSyncProvider({ children }: { children?: ReactNode }) {
  const [isSyncing, setIsSyncing] = useState(false);
  
  useGlobalBackgroundSync(setIsSyncing);
  
  return (
    <BackgroundSyncContext.Provider value={{ isSyncing, setIsSyncing }}>
      {children}
    </BackgroundSyncContext.Provider>
  );
}
